<template>
    <select @change="onChange()" ref="unloadDropdown">
        <option v-if="unloadUnits.length === 0" value="-1"> No Units Loaded </option>
        <option v-else value="-1"> Select a unit to unload </option>
        <option v-for="(unit, index) in unloadUnits" :key="index" :value="index">  {{ getUnitLabel(unit) }} </option>
    </select>
</template>

<script>
export default {
    inject: ['game'],
    props: {
        unloadUnits: {
            type: Array,
            required: true
        }
    },
    methods: {
        getUnitLabel(unit){
            let unitLabel = unit.name;
            if(unit.isVehicle){
                const unitCount = this.game.countUnitsOnVehicle(unit);
                if(unitCount > 1){
                    unitLabel += ` [${unitCount} Units]`;
                }
                else if(unitCount === 1){
                    unitLabel += ` [1 Unit]`;
                }
            }
            if(unit.isCarryingFlag){
                unitLabel += ' (Carrying flag)';
            }
            return unitLabel;
        },
        onChange() {
            this.game.setUnloadingUnit(this.$refs.unloadDropdown.value);
        },
    }
}
</script>

<style>

</style>